<template>
  <div class="shadow-sm rounded-xl border">
    <div class="flex p-3">
     
    </div>
    <a-row type="flex" justify="space-between" align="center">
      <h3 class="text-sm font-medium text-black pl-2">{{ data.username }}</h3>
      <div class=" pr-2">
        <a
          :href="data.tiktok_link"
          target="_blank"
          align="right"
          class="flex justify-center items-center content-center w-8 h-8 border border-indigo-600 p-1 rounded-lg font-semibold text-sm"
        >
          <Icon
            name="Tiktok"
            viewbox="0 0 36 36"
            fill="#667eea"
            stroke="#667eea"
          />
        </a>
      </div>
    </a-row>

    <div
      class="mb-2"
      :class="{ clamp: primaryTextClamp }"
      @click="togglePrimaryTextClamp"
    >
      <p
        class="text-x p-3 pt-0 leading-4 whitespace-pre-wrap font-sans tracking-tight"
      >
        {{ data.description }}
      </p>
    </div>
    <div>
      <div class="square" v-if="typeof data.download_link == 'string'">
        <video
          class="w-full"
          controls
          v-if="data.download_link.includes('.mp4')"
        >
          <source :src="data.download_link" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon },
  props: {
    data: Object,
  },
  setup() {
    const primaryTextClamp = ref(true);

    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value;
    };

    return { primaryTextClamp, togglePrimaryTextClamp };
  },
};
</script>

<style>
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  background-color: black;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.tiktok__icon {
  margin-right: 0px;
  padding-right: 0px;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  background-color: rgb(245, 246, 247);
  border-color: rgb(218, 221, 225);
  height: 28px;
  border-radius: 2px;

  background-position: 0 0;
  border: 1px solid;
  border-radius: 2px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
